<script>
export default {
  name: 'NavigationBar',
  props: {
    back: { type: Boolean, default: () => false },
    backTo: { type: [String, Object, Number], default: () => '/' }
  },
  methods: {
    goBack() {
      const { backTo } = this

      if (this.lodash.isNumber(backTo)) {
        return this.$router.go(backTo)
      }

      this.$router.push(backTo)
    }
  }
}
</script>

<template>
  <v-app-bar color="white" flat app>
    <v-btn v-if="back" icon @click="goBack">
      <v-icon color="black" size="18">$vuetify.icons.arrowBack</v-icon>
    </v-btn>
    <v-btn
      v-if="!back"
      icon
      class="mt-5 d-lg-none"
      @click="$emit('openDrawer')"
    >
      <v-icon color="black" size="18">$vuetify.icons.menu</v-icon>
    </v-btn>
    <v-spacer />
  </v-app-bar>
</template>

<style lang="sass">
.v-app-bar.v-app-bar--fixed + .v-content
  margin-top: 56px
</style>
